"use strict";
/** Πίνακας κατάστασης προσφορών — κοινό web, mobile & backend */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OFFER_STATUS_ACCENT = exports.OFFER_STATUS_TONE = exports.OFFER_STATUS_LABELS = exports.OFFER_STATUS_KEYS = exports.OFFER_BOARD_COLUMN_LABELS = exports.OFFER_BOARD_COLUMNS = void 0;
exports.isOfferStatusKey = isOfferStatusKey;
exports.offerStatusTone = offerStatusTone;
exports.offerStatusLabel = offerStatusLabel;
exports.followUpSentCount = followUpSentCount;
exports.hasSentFollowUp = hasSentFollowUp;
exports.followUpSentBadgeLabel = followUpSentBadgeLabel;
exports.offerBoardColumn = offerBoardColumn;
exports.groupOffersByBoardColumn = groupOffersByBoardColumn;
exports.OFFER_BOARD_COLUMNS = ['DRAFT', 'SENT', 'ACCEPTED', 'REJECTED'];
exports.OFFER_BOARD_COLUMN_LABELS = {
    DRAFT: 'Πρόχειρο',
    SENT: 'Σταλμένη',
    ACCEPTED: 'Αποδοχή',
    REJECTED: 'Απόρριψη',
};
exports.OFFER_STATUS_KEYS = [
    'DRAFT',
    'SENT',
    'ACCEPTED',
    'REJECTED',
    'ARCHIVED',
];
exports.OFFER_STATUS_LABELS = {
    DRAFT: 'Πρόχειρο',
    SENT: 'Σταλμένη',
    ACCEPTED: 'Αποδοχή',
    REJECTED: 'Απόρριψη',
    ARCHIVED: 'Αρχειοθετημένη',
};
/** Badge / φίλτρο κατάστασης — ίδιο χρώμα σε web & mobile */
exports.OFFER_STATUS_TONE = {
    DRAFT: 'amber',
    SENT: 'sky',
    ACCEPTED: 'emerald',
    REJECTED: 'red',
    ARCHIVED: 'zinc',
};
/** Αριστερή λωρίδα λίστας (Tailwind) — web */
exports.OFFER_STATUS_ACCENT = {
    DRAFT: 'bg-amber-400',
    SENT: 'bg-sky-400',
    ACCEPTED: 'bg-emerald-500',
    REJECTED: 'bg-red-500',
    ARCHIVED: 'bg-zinc-400',
};
function isOfferStatusKey(status) {
    return exports.OFFER_STATUS_KEYS.includes(status);
}
function offerStatusTone(status) {
    return isOfferStatusKey(status) ? exports.OFFER_STATUS_TONE[status] : 'zinc';
}
function offerStatusLabel(status) {
    return isOfferStatusKey(status) ? exports.OFFER_STATUS_LABELS[status] : status;
}
function followUpSentCount(offer) {
    var _a, _b;
    return (_b = (_a = offer.followUp) === null || _a === void 0 ? void 0 : _a.sent) !== null && _b !== void 0 ? _b : 0;
}
function hasSentFollowUp(offer) {
    return offer.status === 'SENT' && followUpSentCount(offer) > 0;
}
function followUpSentBadgeLabel(count) {
    if (count === 1)
        return '1 follow-up';
    return `${count} follow-up`;
}
function offerBoardColumn(offer) {
    if (offer.status === 'DRAFT')
        return 'DRAFT';
    if (offer.status === 'SENT')
        return 'SENT';
    if (offer.status === 'ACCEPTED')
        return 'ACCEPTED';
    if (offer.status === 'REJECTED')
        return 'REJECTED';
    return null;
}
function groupOffersByBoardColumn(offers) {
    const g = {
        DRAFT: [],
        SENT: [],
        ACCEPTED: [],
        REJECTED: [],
    };
    for (const o of offers) {
        const col = offerBoardColumn(o);
        if (col)
            g[col].push(o);
    }
    return g;
}
